import React, { useRef, useState } from "react"
import moment from "moment"
import "moment/locale/bg"
import { Popover, Typography, Box } from "@mui/material"
import { DateCalendar } from "@mui/x-date-pickers/DateCalendar"
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider"
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment"
import { YearCalendar } from "@mui/x-date-pickers"
// import calendarImage from '@/assets/img/app/icons/calendar.svg'
// import arrowDownImage from '@/assets/img/app/icons/arrow-down.svg'

moment.locale("bg")

export default function DateRange({
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  disabled,
  yearOnly = false,
}) {
  const containerRef = useRef(null)
  const [anchorEl, setAnchorEl] = useState(null)
  const [pickerType, setPickerType] = useState(null) // 'start' or 'end'

  const formatDate = (dateString) => {
    if (!dateString) return ""

    if (yearOnly) return `${dateString} г.`

    return moment(dateString).format("DD MMM,YY")
  }

  const handleStartDateChange = (newValue) => {
    const newStartDate = newValue
      ? newValue.format(yearOnly ? "YYYY" : "YYYY-MM-DD")
      : null

    // If new start date is after end date, adjust end date
    if (newStartDate && endDate && newStartDate > endDate) {
      onEndDateChange?.(newStartDate)
    }

    onStartDateChange?.(newStartDate)

    // Close current popover and auto-open end date picker
    setPickerType("end")
  }

  const handleEndDateChange = (newValue) => {
    const newEndDate = newValue
      ? newValue.format(yearOnly ? "YYYY" : "YYYY-MM-DD")
      : null
    onEndDateChange?.(newEndDate)
    handleClose()
  }

  const handleClose = () => {
    setAnchorEl(null)
    setPickerType(null)
  }

  const handleContainerClick = (e) => {
    // Don't open start picker if clicking on end date area
    if (e.target.closest(".date-range-end")) {
      return
    }

    if (disabled) return

    setAnchorEl(containerRef.current)
    setPickerType("start")
  }

  const handleEndClick = (e) => {
    e.stopPropagation()

    if (disabled) return

    setAnchorEl(containerRef.current)
    setPickerType("end")
  }

  const open = Boolean(anchorEl)

  return (
    <LocalizationProvider dateAdapter={AdapterMoment} adapterLocale="bg">
      <div
        className="date-range-picker"
        ref={containerRef}
        onClick={handleContainerClick}
        style={{
          pointerEvents: disabled ? "none" : "auto",
          opacity: disabled ? 0.4 : 1,
        }}
      >
        {/* <img src={calendarImage} alt="calendar" className="date-range-icon" /> */}

        <div className="date-range-display">
          {!startDate || !String(startDate).length ? (
            <span
              style={{
                paddingLeft: "5px",
              }}
            >
              Избор на период
            </span>
          ) : (
            <>
              <span
                className="date-range-start"
                style={yearOnly ? { width: "60px" } : {}}
              >
                {!startDate || !String(startDate).length
                  ? "Избор"
                  : formatDate(startDate)}
              </span>
              <span className="date-range-separator">- </span>
              <span
                className="date-range-end"
                onClick={handleEndClick}
                style={yearOnly ? { width: "60px" } : {}}
              >
                {!endDate || !String(endDate).length
                  ? "Избор"
                  : formatDate(endDate)}
              </span>
            </>
          )}
        </div>

        {/* <img src={arrowDownImage} alt="dropdown" className="date-range-arrow" /> */}
      </div>

      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        slotProps={{
          paper: {
            sx: {
              mt: 1,
              borderRadius: 2,
            },
          },
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{ pt: 2, px: 3, color: "text.secondary", fontWeight: 600 }}
        >
          {pickerType === "start" ? "Начална дата" : "Крайна дата"}
        </Typography>
        <Box>
          {yearOnly ? (
            <>
              {pickerType === "start" && (
                <YearCalendar
                  value={startDate ? moment(startDate, "YYYY") : null}
                  maxDate={endDate ? moment(endDate, "YYYY") : undefined}
                  onChange={handleStartDateChange}
                />
              )}
              {pickerType === "end" && (
                <YearCalendar
                  value={endDate ? moment(endDate, "YYYY") : null}
                  minDate={startDate ? moment(startDate, "YYYY") : undefined}
                  onChange={handleEndDateChange}
                />
              )}
            </>
          ) : (
            <>
              {pickerType === "start" && (
                <DateCalendar
                  value={startDate ? moment(startDate) : null}
                  maxDate={endDate ? moment(endDate) : undefined}
                  onChange={handleStartDateChange}
                />
              )}
              {pickerType === "end" && (
                <DateCalendar
                  value={endDate ? moment(endDate) : null}
                  minDate={startDate ? moment(startDate) : undefined}
                  onChange={handleEndDateChange}
                />
              )}
            </>
          )}
        </Box>
      </Popover>
    </LocalizationProvider>
  )
}
